import {useCallback} from 'react';
import deleteTodoDoc from '../../api/todo/deleteTodoDoc';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export default function useDeleteTodo(uid: string | undefined) {
  const deleteFn = useCallback(
    (todoId: string) => {
      if (!uid) throw new Error('Todo collection not found');
      return deleteTodoDoc(uid, todoId);
    },
    [uid],
  );
  const {fn, loading, error} = useFunctionWrap(deleteFn);

  return {
    deleteTodo: fn,
    loading,
    error,
  };
}
